import { pipeline } from 'stream/promises';
import { createBrotliCompress } from 'zlib';
import { createWriteStream } from 'fs';
import * as path from 'path';
import { spawn } from 'child_process';

export const compressBundle = async (platformDir: string, bundleOutputCompressed: string) => {
  return new Promise<void>((resolve, reject) => {
    const tar = spawn('tar', [
      '--exclude=*/.DS_Store/*',
      '--exclude=._*',
      '--exclude=*/._*',
      '-c',
      '-C',
      path.dirname(platformDir), path.basename(platformDir)
    ]);
    const writeStream = createWriteStream(bundleOutputCompressed);
    const brotliCompress = createBrotliCompress();

    let hasError = false;

    // Handle tar process errors
    tar.on('error', (error) => {
      if (!hasError) {
        hasError = true;
        reject(error);
      }
    });

    tar.stderr.on('data', (data) => {
      if (!hasError) {
        hasError = true;
        reject(new Error(`tar error: ${data.toString()}`));
      }
    });

    // Set up the pipeline
    pipeline(tar.stdout, brotliCompress, writeStream)
      .then(() => {
        if (!hasError) {
          resolve();
        }
      })
      .catch((error) => {
        if (!hasError) {
          hasError = true;
          reject(error);
        }
      });

    // Handle tar process exit
    tar.on('close', (code) => {
      if (!hasError && code !== 0) {
        hasError = true;
        reject(new Error(`tar process exited with code ${code}`));
      }
    });
  });
}
